import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-w.svg';
import bgNav from '../assets/bgnav.gif';


class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {isToggleOn: false};

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState(prevState => ({
      isToggleOn: !prevState.isToggleOn
    }));
  }

  render() {
    return (

 
      <header>
        <div className="absolute xl:fixed pin-t pin-l w-1/4 md:mt-16 md:ml-16 xl:mt-24 xl:ml-24 z-30 logo">
          <Link className="no-underline font-bold mr-2 text-base" to='/'><img src={logo} className="w-24 logo text-white" alt="logo" /></Link>
        </div>

        <div className="absolute xl:fixed pin-r pin-t w-1/4 md:mt-16 md:mr-16 xl:mt-24 xl:mr-24 z-60 text-right menu">
          <button onClick={this.handleClick}><i className={this.state.isToggleOn ? "fas fa-times text-white text-4xl pt-3-1 bg-black h-16 w-16" : "fas fa-bars text-black text-4xl pt-3-1 bg-white h-16 w-16"}></i></button>
        </div>



        <div className={this.state.isToggleOn ? "w-full h-screen fixed pin-t pin-r z-50 flex menu-open menu-wrapper" : "w-full h-screen fixed pin-t pin-r z-50 flex menu-hidden menu-wrapper"}>
          <div className="hidden flex-1 bg-black h-screen lg:flex items-center menu-left">
            <div className="flex-1 w-full px-32">
              <img src={bgNav} className="w-full" alt="logo" />
            </div>
          </div>
          <div className="flex-1 bg-white h-screen flex items-center menu-right">
            <div className="flex-1 w-full px-12 md:px-24">
             <Link className="no-underline nav-link text-black w-full block font-heading font-semibold text-5xl md:text-huge-md py-2" to='/' onClick={this.handleClick}><span>Home</span></Link>
             <Link className="no-underline nav-link text-black w-full block font-heading font-semibold text-5xl md:text-huge-md py-2" to='/work' onClick={this.handleClick}><span>Works</span></Link>
             <Link className="no-underline nav-link text-black w-full block font-heading font-semibold text-5xl md:text-huge-md py-2" to='/projects' onClick={this.handleClick}><span>Projects</span></Link>
             <Link className="no-underline nav-link text-black w-full block font-heading font-semibold text-5xl md:text-huge-md py-2" to='/about' onClick={this.handleClick}><span>About</span></Link>
            </div>
          </div>
          
        </div>
        
      </header>

      

    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js